import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import gsap from 'gsap'
import { useGSAP } from '@gsap/react'

import './styles/nav.css'
import classNames from './utils'


const Nav = () => {

  gsap.registerPlugin(useGSAP)

  const isMobile = window.innerWidth <= 768
  const [showMenu, setShowMenu] = useState(!isMobile)

  useGSAP(() => {
    gsap.fromTo('.nav-list-item',
      { x: '-100px', opacity: 0, }, {
        x: '10px', opacity: 1,
        delay: 0.5,
        stagger: 0.15,
        duration: 0.25,
        ease: 'easeIn',
      })

    gsap.fromTo('.links svg',
      { y: '+1', opacity: 0, }, {
        y: 0, opacity: 1,
        stagger: 0.3,
        duration: 0.75,
        ease: 'easeOut',
      })
  })

  const renderSocialLinks = () => {
    return (
      <div className="links">
        <a href="https://instagram.com/psychdotcat/" target="_blank" rel="noopener noreferrer">
          <svg viewBox="0 0 56.7 56.7">
            <defs>
              <linearGradient id="links-gradient" x1="50%" x2="50%" y1="0%" y2="100%">
                <stop offset="0%" stopColor="#FF4500" />
                <stop offset="60%" stopColor="#9E0086" />
                <stop offset="100%" stopColor="#130065" />
              </linearGradient>
            </defs>
            <path d="M28.2 16.7c-7 0-12.8 5.7-12.8 12.8s5.7 12.8 12.8 12.8S41 36.5 41 29.5s-5.8-12.8-12.8-12.8zm0 21c-4.5 0-8.2-3.7-8.2-8.2s3.7-8.2 8.2-8.2 8.2 3.7 8.2 8.2-3.7 8.2-8.2 8.2z" />
            <circle cx="41.5" cy="16.4" r="2.9" />
            <path d="M49 8.9c-2.6-2.7-6.3-4.1-10.5-4.1H17.9c-8.7 0-14.5 5.8-14.5 14.5v20.5c0 4.3 1.4 8 4.2 10.7 2.7 2.6 6.3 3.9 10.4 3.9h20.4c4.3 0 7.9-1.4 10.5-3.9 2.7-2.6 4.1-6.3 4.1-10.6V19.3c0-4.2-1.4-7.8-4-10.4zm-.4 31c0 3.1-1.1 5.6-2.9 7.3s-4.3 2.6-7.3 2.6H18c-3 0-5.5-.9-7.3-2.6C8.9 45.4 8 42.9 8 39.8V19.3c0-3 .9-5.5 2.7-7.3 1.7-1.7 4.3-2.6 7.3-2.6h20.6c3 0 5.5.9 7.3 2.7 1.7 1.8 2.7 4.3 2.7 7.2v20.6z" />
          </svg>
        </a>

        <a href="https://pinterest.com/psychdotcat/" target="_blank" rel="noopener noreferrer">
          <svg viewBox="0 0 56.693 56.693">
            <defs>
              <linearGradient id="links-gradient" x1="50%" x2="50%" y1="0%" y2="100%">
                <stop offset="0%" stopColor="#FF4500" />
                <stop offset="60%" stopColor="#9E0086" />
                <stop offset="100%" stopColor="#130065" />
              </linearGradient>
            </defs>
            <path d="M30.374 4.622c-13.586 0-20.437 9.74-20.437 17.864 0 4.918 1.862 9.293 5.855 10.922.655.27 1.242.01 1.432-.715.132-.5.445-1.766.584-2.295.191-.717.117-.967-.412-1.594-1.151-1.357-1.888-3.115-1.888-5.607 0-7.226 5.407-13.695 14.079-13.695 7.679 0 11.898 4.692 11.898 10.957 0 8.246-3.649 15.205-9.065 15.205-2.992 0-5.23-2.473-4.514-5.508.859-3.623 2.524-7.531 2.524-10.148 0-2.34-1.257-4.292-3.856-4.292-3.058 0-5.515 3.164-5.515 7.401 0 2.699.912 4.525.912 4.525l-3.678 15.582c-1.092 4.625-.164 10.293-.085 10.865.046.34.482.422.68.166.281-.369 3.925-4.865 5.162-9.359.351-1.271 2.011-7.859 2.011-7.859.994 1.896 3.898 3.562 6.986 3.562 9.191 0 15.428-8.379 15.428-19.595.001-8.483-7.183-16.382-18.101-16.382z" />
          </svg>
        </a>

        <a href="https://etsy.com/people/sb1d23xts3o4dbms" target="_blank" rel="noopener noreferrer">
          <svg viewBox="0 0 384 512">
            <defs>
              <linearGradient id="links-gradient" x1="50%" x2="50%" y1="0%" y2="100%">
                <stop offset="0%" stopColor="#FF4500" />
                <stop offset="60%" stopColor="#9E0086" />
                <stop offset="100%" stopColor="#130065" />
              </linearGradient>
            </defs>
            <path d="M384 348c-1.75 10.75-13.75 110-15.5 132-117.879-4.299-219.895-4.743-368.5 0v-25.5c45.457-8.948 60.627-8.019 61-35.25 1.793-72.322 3.524-244.143 0-322-1.029-28.46-12.13-26.765-61-36v-25.5c73.886 2.358 255.933 8.551 362.999-3.75-3.5 38.25-7.75 126.5-7.75 126.5H332C320.947 115.665 313.241 68 277.25 68h-137c-10.25 0-10.75 3.5-10.75 9.75V241.5c58 .5 88.5-2.5 88.5-2.5 29.77-.951 27.56-8.502 40.75-65.251h25.75c-4.407 101.351-3.91 61.829-1.75 160.25H257c-9.155-40.086-9.065-61.045-39.501-61.5 0 0-21.5-2-88-2v139c0 26 14.25 38.25 44.25 38.25H263c63.636 0 66.564-24.996 98.751-99.75H384z" />
          </svg>
        </a>

        <a href="https://x.com/psychdotcat" target="_blank" rel="noopener noreferrer">
          <svg viewBox="0 0 56.693 56.693">
            <defs>
              <linearGradient id="links-gradient" x1="50%" x2="50%" y1="0%" y2="100%">
                <stop offset="0%" stopColor="#FF4500" />
                <stop offset="60%" stopColor="#9E0086" />
                <stop offset="100%" stopColor="#130065" />
              </linearGradient>
            </defs>
            <path d="M52.837 15.065a20.11 20.11 0 0 1-5.805 1.591 10.125 10.125 0 0 0 4.444-5.592 20.232 20.232 0 0 1-6.418 2.454 10.093 10.093 0 0 0-7.377-3.192c-5.581 0-10.106 4.525-10.106 10.107 0 .791.089 1.562.262 2.303-8.4-.422-15.848-4.445-20.833-10.56a10.055 10.055 0 0 0-1.368 5.082c0 3.506 1.784 6.6 4.496 8.412a10.078 10.078 0 0 1-4.578-1.265l-.001.128c0 4.896 3.484 8.98 8.108 9.91a10.162 10.162 0 0 1-4.565.172c1.287 4.015 5.019 6.938 9.441 7.019a20.276 20.276 0 0 1-12.552 4.327c-.815 0-1.62-.048-2.411-.142a28.6 28.6 0 0 0 15.493 4.541c18.591 0 28.756-15.4 28.756-28.756 0-.438-.009-.875-.028-1.309a20.47 20.47 0 0 0 5.042-5.23z" />
          </svg>
        </a>
      </div>
    )
  }

  return (
    <div className={classNames('nav', {'active': showMenu})}>
      {showMenu ? (
        <React.Fragment>
          {renderSocialLinks()}
          <ul className="nav-list">
            <li className="nav-list-item">
              <b>
                <Link to="/chat">Chat</Link>
              </b>
            </li>
            <li className="nav-list-item">
              <b>
                <Link to="/posts">Posts</Link>
              </b>
            </li>
            <li className="nav-list-item">
              <b>
                <a href="https://www.redbubble.com/shop/ap/172169091"
                  target="_blank" rel="noopener noreferrer">Merch</a></b>
            </li>
            <li className="nav-list-item" style={{'userSelect': 'text'}}>
              <b>
                <a href="mailto:mail@psych.cat">
                  mail@psych.cat
                </a>
              </b>
            </li>
            <br/>
            <li className="nav-list-item">
              2025 &copy; psych.cat
            </li>
          </ul>
        </React.Fragment>
      ) : (
        <p onClick={() => setShowMenu(true)}>Menu</p>
      )}
    </div>
  )

}


export default Nav
